import {Form} from "antd";
import DG_Form from "../../../custom/data-entry/form";
import React, {useEffect, useState} from "react";
import Content from "./content";
import {mapDatasource} from "./mapDatasource";
import {getCustomerById, updateCustomer} from "../../../api/customer";
import {DG_Format_Status} from "../../../format/Status";
import {useDispatch, useSelector} from "react-redux";
import {onReloadData} from "../../../redux/actions/layout/interaction/action";

const Update = ({onLoading, list, id, onCancel}) => {

    const dispatch = useDispatch()
    const { reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [form] = Form.useForm()
    const [datasource, setDatasource] = useState([])
    const [loggedIn, setLoggedIn] = useState()

    const mapDatasourceList = (data)=>{
        if (!data) {
            return [];
        }
        return data?.map((item) => {
            return {
                ...item,
                statusFormat: DG_Format_Status(item.status)
            };
        });
    }

    useEffect(()=>{
        getCustomerById(id).then(r => {
            form.setFieldsValue(r);
            setDatasource(mapDatasourceList(r.list))
            setLoggedIn(r.loggedIn)
        })
            .catch(()=>{})
    },[form, id])
    const onFinish = (value) => {
        value = {
            ...value,
            list : mapDatasource(datasource)
        }
        onLoading(true)
        updateCustomer(id, value).then(r =>{
            dispatch(onReloadData(!reloadData))
            onLoading(false)
            onCancel()
        })
            .catch(ex=>{
                onLoading(false)
            })
    }

    return (
        <>
            <DG_Form
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                autoComplete="off"
                form={form}
                mode={"add"}
                onFinish={onFinish}
                colon={false}
                labelAlign="left"
                scrollToFirstError={true}
            >
                <Content list={list}
                         form={form}
                         datasource={datasource}
                         onDatasource={(value)=>{
                             setDatasource(mapDatasourceList(datasource.concat(value)))
                         }} id={id} loggedIn={loggedIn}/>

            </DG_Form>
        </>
    )
}

export default Update
